import { FieldContainer } from "@comet/admin";
import { type FC, type PropsWithChildren, type ReactNode } from "react";

interface Props {
    label?: string | ReactNode;
    required?: boolean;
}

export const CommonFieldContainer: FC<PropsWithChildren<Props>> = (props) => <FieldContainer {...props} variant="horizontal" />;
